import { Injectable } from '@angular/core'
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { STORAGE_CUSTOMER_JWT } from '../constants';
import decode from 'jwt-decode'
import { AuthService } from './auth.service';

@Injectable()
export class NonWholesaleGuardService implements CanActivate {

    constructor(private auth: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        try {
            if ((window as any).disabled_d2c) {
                this.router.navigate(['/wholesale'])
                return false;
            }

            const token = localStorage.getItem(STORAGE_CUSTOMER_JWT);
            const tokenPayload = token ? decode(token) : false
            if (!this.auth.isAuthenticated() || !tokenPayload || !tokenPayload.is_wholesale) {
                return true;
            } else {
                this.router.navigate(['/wholesale'])
                return false;
            }
        } catch(e) {
            return true;
        }
    }
}